import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';
import { getDemandTrapText, getPhoneText, getVertical, getName } from '../utils';
import { getOfferType } from '../utils/jsonQuery';
import { Trap, ITrapProps } from '../components/Trap';
import { FOfferType } from '../../../utils/offer_type';
import { demandCloseSuccessModalAction, demandShowSuccessModal } from '@cian/demand-trap-widget';
import { ICreateMessageForOfferRequest } from '../../../repositories/demand/v2/create-message-for-offer';
import { sendDemandRequest } from '../../../store/demand/demandThunk';
import { withObservation } from '@cian/component-observer';
import { sendTeaserEvent } from '../utils/TeaserEvent';
import { isFakeEmail } from '../../../utils/validate';

const defaultHeader = 'Нужна помощь в подборе лучших предложений?';
const newBuildingHeader = 'Лучшие предложения по новостройкам';

export const mapStateToProps = (state: IState) => {
  const {
    offerData: {
      offer: { geo, id },
      demandJsonQuery,
      user,
    },
    soprApi,
  } = state;
  const offerType = getOfferType(demandJsonQuery);
  const firstName = user && user.isAuthenticated ? user.firstName : '';
  const lastName = user && user.isAuthenticated ? user.lastName : '';
  const userId = state.tracking ? state.tracking.user.userId : null;
  const abGroup = state.tracking ? state.tracking.user.abGroup : null;

  return {
    isSuccessModalOpen: demandShowSuccessModal(state),
    name: getName(firstName || '', lastName || ''),
    phone: getPhoneText(user),
    email: user && user.isAuthenticated && user.email && !isFakeEmail(user.email) ? user.email : '',
    vertical: getVertical(offerType),
    displayName: (user && user.isAuthenticated && user.companyName) || undefined,
    publicProfile: Boolean(user && user.isAuthenticated && user.isProfi),
    disclaimerText: getDemandTrapText(geo, demandJsonQuery),
    isAuthenticated: Boolean(user && user.isAuthenticated),
    disclaimerHeader: offerType === FOfferType.FlatNew ? newBuildingHeader : defaultHeader,
    offerId: id,
    userId,
    abGroup,
    soprApi,
  };
};

export const actions = (dispatch: Dispatch<IState>) => ({
  demandCloseSuccessModalAction() {
    dispatch(demandCloseSuccessModalAction());
  },
  demandRequestCreateMessageStartAction(data: ICreateMessageForOfferRequest) {
    dispatch(sendDemandRequest(data));
  },
});

// После переопределения Trap из функционального компонента в класс, ts решил, что offerId может быть undefined
// Нигде в проекте offerId не может быть undefined, такого тайпинга вообще нет, источник проблемы не нашли
//@ts-ignore
export const TrapContainer = connect(mapStateToProps, actions)(Trap);

export const transformTrapOnCardPageProps = ({ props, isViewed }: { props: ITrapProps; isViewed: boolean }) => ({
  soprApi: props.soprApi,
  user_id: props.userId,
  pageType: 'Card',
  position: 1,
  device_type: 'desktop',
  ab_group: props.abGroup,
  block_type: 'demand',
  isTeaserShow: (isViewed ? 1 : 0) as 0 | 1,
});

export const observerOptions = {
  onChange: (events: Array<{ props: ITrapProps; isViewed: boolean }>) =>
    sendTeaserEvent(events.map(transformTrapOnCardPageProps)),
};

export const ObservableTrapContainer = connect(
  mapStateToProps,
  actions,
)(
  //@ts-ignore
  withObservation<ITrapProps>(Trap, observerOptions),
);
